(function() {
  // Patch TouchEvent jika tidak ada
  if (typeof window.TouchEvent !== "function") {
    window.TouchEvent = class TouchEvent extends Event {
      constructor(type, params) {
        super(type, params);
        this.touches = [];
        this.targetTouches = [];
        this.changedTouches = [];
      }
    };
  }

  // Patch document.createEvent agar support "TouchEvent"
  const originalCreateEvent = document.createEvent.bind(document);
  document.createEvent = function(type) {
    if (type === "TouchEvent") {
      // Jangan panggil originalCreateEvent karena pasti error di desktop
      return new window.TouchEvent("touchstart");
    }
    return originalCreateEvent(type);
  };
})();
